module.exports = __webpack_public_path__ + "media/images/delete-1e542534b8e5f3007377a80c15eb1672.svg";